import Shepherd from 'shepherd.js';

export default {

    tour(){

        if($('.network-administration-pipelines').length){
    
            ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
                var data = {
                    'page': 'network-administration-pipelines-3'
                };
                axios.post("/api/v1/onboarding", data)
                .then((response) =>  {
                }).catch(function (error) {
                    console.log('onboarding logged')
                });
            }));
    
            var dataType = $('.network-administration-pipelines').attr('data-type');
            
            const tour3 = new Shepherd.Tour({
                defaultStepOptions: {
                    cancelIcon: {
                        enabled: true
                    },
                    classes: 'shepherd-container',
                    scrollTo: { behavior: 'smooth', block: 'center' }
                },
                useModalOverlay: true
            });
            
            tour3.addStep({
                title: 'Moving an application between stages',
                text: "Now that you've added this application to a stage, you can move it to different stages. You can either drag it between different stages on this page, or change it using the sidebar dropdown on the applications individual page. We keep a history of the applications stage displayed in the same sidebar so you know when it changed and what to.",
                buttons: [
                    {
                        action() {
                            return this.next();
                        },
                        classes: 'btn btn--secondary',
                        text: 'Next'
                    }
                ],     
                attachTo: {
                    element: '.list-group-item',
                    on: 'right'
                },       
                id: 'step-1'
            });
            
            tour3.addStep({
                title: 'Viewing and Deleting',
                text: "When you hover over an application you will see two buttons; An eye icon for view, and a trash icon for delete. If you click view, you will be taken to that application's individual page. If you click delete, it will not delete the application itself, but will remove its reference to this stage.",
                attachTo: {
                    element: '.list-group-item',
                    on: 'right'
                },
                buttons: [
                    {
                        action() {
                            return this.back();
                        },
                        classes: 'btn btn--border',
                        text: 'Back'
                    },
                    {
                        action() {
                            return this.next();
                        },
                        classes: 'btn btn--secondary',
                        text: 'Next'
                    }
                ],
                id: 'step-3'
            });
            
            tour3.addStep({
                title: 'Thats all!',
                text: "That's everything that covers how to use pipelines, however, if you have any issues or need any advice don't hesitate to reach out to our team and we'll give you a hand.",
                buttons: [
                    {
                        action() {
                            return this.back();
                        },
                        classes: 'btn btn--border',
                        text: 'Back'
                    },
                    {
                        action() {
                            return this.complete();
                        },
                        classes: 'btn btn--secondary',
                        text: 'Finish'
                    }
                ],
                id: 'step-3'
            });
    
            if(!$('.onboarding-network-administration-pipelines-3').length){
                setTimeout(function(){
                    tour3.start();
                }, 500);
            }
        }
    }
}
